import cx from 'classnames'
import Styles from './SortIndicator.module.scss'

import { SortIndicatorProps } from './Types'
import { ArrowUpSm } from 'blaze-ui/icons'

const SortIndicator = ({ direction }: SortIndicatorProps) => {
  return (
    <span className={cx(Styles.arrow, Styles[direction])}>
      <ArrowUpSm color="var(--dark-60)" />
    </span>
  )
}

export { SortIndicator }
